import { render, staticRenderFns } from "./PlanSpecialist.vue?vue&type=template&id=3421a132&scoped=true"
import script from "./PlanSpecialist.vue?vue&type=script&lang=js"
export * from "./PlanSpecialist.vue?vue&type=script&lang=js"
import style0 from "./PlanSpecialist.vue?vue&type=style&index=0&id=3421a132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421a132",
  null
  
)

export default component.exports